import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type IndiaPincode = {
    cityId: Uuid;
    id: Uuid;
    latitude: number;
    longitude: number;
    pincode: string;
};

export const indiaPincodeValidator: zod.ZodType<IndiaPincode> = zod.strictObject({
    cityId: uuidZodValidator,
    id: uuidZodValidator,
    latitude: zod.number(),
    longitude: zod.number(),
    pincode: zod.string(),
});
